module.exports = __webpack_public_path__ + "img/24_20.c00e245c.png";